import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supportApi } from './api';

export function useSupportUnread(): number {
  const q = useQuery({
    queryKey: ['support', 'unread'],
    queryFn: () => supportApi.unreadCount(),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
  return q.data?.count ?? 0;
}

export function useSupportTickets() {
  return useQuery({
    queryKey: ['support', 'tickets'],
    queryFn: () => supportApi.list(),
    staleTime: 30_000,
  });
}

export function useSupportTicket(id: number | undefined) {
  return useQuery({
    queryKey: ['support', 'tickets', id],
    queryFn: () => supportApi.get(id!),
    enabled: !!id,
  });
}

export function useReplyTicket(id: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (nachricht: string) => supportApi.reply(id, nachricht),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['support', 'tickets', id] });
    },
  });
}
